import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityTraffic/img/1.avif';
import image2 from '@src/assets/images/solution/cityTraffic/img/2.avif';
import image3 from '@src/assets/images/solution/cityTraffic/img/3.avif';
import image4 from '@src/assets/images/solution/cityTraffic/img/4.avif';
import image5 from '@src/assets/images/solution/cityTraffic/img/5.avif';
import image6 from '@src/assets/images/solution/cityTraffic/img/6.avif';
import image7 from '@src/assets/images/solution/cityTraffic/img/7.avif';
import image8 from '@src/assets/images/solution/cityTraffic/img/8.avif';
import image9 from '@src/assets/images/solution/cityTraffic/img/9.avif';

export default {
  type: '교통 솔루션',

  banner: {
    title: 'AI 기반 차량 분석, 고속도로 휴게소 주차를 스마트하게 관리',
    desc: 'PTZ AI 카메라로 주차 구역 내 차량 위치와 번호판을 실시간 인식하여, 휴게소의 혼잡도를 완화하고 운영 효율을 높이며, 고객의 이용 경험을 향상시킵니다.',
  },

  video: {
    title: 'AI 기반 주차 분석으로 운영과 편의를 동시에 최적화하세요',
    desc: 'AI 카메라가 실시간으로 차량 위치와 번호판을 인식하여, 주차 공간 가용 현황을 실시간 표시하고, 사용자 정보와 연계해 스마트 운영이 가능합니다.',
    play: video,
  },

  func: [
    {
      theme: 'AI 기반 차량 추적 및 환경 대응',
      title: 'PTZ 카메라로 넓은 공간 정밀 관제',
      desc: '조명 타워에 설치된 PTZ 카메라 다수를 연동하여 넓은 주차 공간을 빈틈없이 커버합니다. 필요 구간은 고배율 줌으로 정밀 감시하며, 주차 흐름과 혼잡 구역을 실시간 추적합니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'AI 모델의 현장 데이터 기반 성능 향상',
      desc: 'ORBRO는 실시간 데이터 증강 기술을 통해 주차장 현장에 맞게 객체 인식 모델을 빠르게 학습시킵니다. 이를 통해 카메라 설치 후 단기간 내 인식률이 급속히 향상됩니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '야간·저조도 환경에서도 안정적 인식',
      desc: '야간이나 어두운 조명 조건에서도 차량의 빠른 움직임을 정확하게 포착할 수 있도록, 저조도 최적화 알고리즘과 하드웨어 NIR 대응 기능이 함께 작동합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '악천후 환경에서의 견고한 성능 유지',
      desc: '눈, 비 등 복잡한 기상조건에서도 차량 추적 성능을 유지할 수 있도록, 날씨 변화에 적응하는 딥러닝 기반 필터링 알고리즘을 적용합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '실내 영역 유동 인구 동시 분석',
      desc: '주차장 인접 실내 공간은 Fisheye 카메라를 활용해 고객의 유동 흐름을 분석합니다. 주차와 매장 간 연결 분석으로 상업적 활용도가 높아집니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '운영 효율 및 위험 감지 자동화',
      title: '차량 진입·출입 트래픽 분석',
      desc: '진출입 구간의 차량 통계를 자동으로 수집해 시간대별 혼잡도를 예측하고, 운영 시간 최적화나 시설 개선 판단의 근거 데이터를 제공합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '역주행 감지 및 알림',
      desc: '차량이 지정된 진행 방향과 반대로 움직일 경우, 즉시 알람을 발생시켜 위험 상황에 신속히 대응할 수 있도록 합니다.<br/><br/> • 특정 구역에서 지정된 방향과 반대로 이동하는 객체 감지<br/><br/> • 휴게소 출구 지역 등에서 역주행 감지 가능<br/><br/> • 역주행 발생 시 알람 기능 제공 (모바일, 관제센터 연동)',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '장기간 방치차량 분석',
      desc: '빠르게 이동하는 진출입로에 장시간 정지하는 보행자를 감지하면 알림이 발생하여 사고 위험을 예방합니다. 차량과 보행자의 상호작용 위험도 함께 분석합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '영상 ROI 기반 성능 최적화 및 개인정보 보호',
      desc: '필요한 화면만 남기고 ROI(관심영역)를 설정하여 불필요한 영상 제거가 가능합니다. 이로 인해 연산 속도가 향상되고, 민감 구역을 비식별화하여 프라이버시를 보호합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '의료 폐기물은 끝까지 긴장을 놓쳐서는 안됩니다. 작은 방심과 실수로도 큰 의료 사고로 이어질 수 있습니다. 따라서 매우 정밀한 관리가 필요하며 안전이 보장되어야 합니다.<br/>오브로는 안전하고 효율적인 의료 시설을 구축하기 위해 다양한 기능을 제공합니다.',
    data: [
      {
        icon: IconBinocularsGray,
        title: 'PTZ 카메라 기반 차량 추적',
        desc: '고배율 PTZ 카메라를 활용해 넓은 주차 공간에서도 차량의 실시간 위치를 정밀하게 추적합니다.',
      },
      {
        icon: IconChartBarGray,
        title: 'AI 객체 인식 모델 적용',
        desc: '차량, 화물차, 보행자 등을 AI가 자동 인식하여 주차 공간 내 모든 객체를 구분 추적합니다.',
      },
      {
        icon: IconClockGray,
        title: '야간·저조도 환경 대응',
        desc: 'AI 모델이 야간 및 조명이 어두운 환경에서도 차량 인식률을 유지하며 안정적으로 작동합니다.',
      },
      {
        icon: IconChartBarGray,
        title: '악천후 대응 알고리즘 내장',
        desc: '눈, 비 등 악천후 상황에서도 정확한 인식이 가능한 영상 보정 및 추적 알고리즘을 탑재합니다.',
      },
      {
        icon: IconChartRadius,
        title: '실내 공간 유동인구 분석',
        desc: 'Fish-eye 카메라를 통해 실내 대기 공간의 인원 흐름을 분석하여 혼잡 구역을 시각화합니다.',
      },
      {
        icon: IconRoute,
        title: '차량 진입·출입량 분석 기능',
        desc: '시간대별로 차량의 진입과 출입 데이터를 수집·분석하여 교통 흐름 개선에 활용할 수 있습니다.',
      },
      {
        icon: IconZoneGray,
        title: '불필요 구역 영상제거(ROI)',
        desc: '촬영 필요 구역만 남기고 나머지 영상은 제거하여 성능을 높이고 개인정보 보호도 강화합니다.',
      },
      {
        icon: IconWarning,
        title: '역주행 감지 알람',
        desc: '차량이 지정된 방향과 반대로 이동하는 경우 즉시 관리자에게 알람이 전송됩니다.',
      },
      {
        icon: IconWarning,
        title: '보행자 장시간 체류 감지',
        desc: '진출입로에서 보행자가 장시간 머무를 경우 위험 요소로 인식하고 즉시 경고합니다.',
      },
      {
        icon: IconDashboard,
        title: 'AI 기반 대시보드 시각화',
        desc: '모든 차량 흐름과 이상 상황을 대시보드에서 실시간 확인하고 AI 분석 결과도 함께 제공합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'officeAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
